module.exports = __webpack_public_path__ + "img/welding-10.5f5353e9.jpg";